import React, { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext.jsx';
import { api } from '../../utils/api.js';

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const [botStatus, setBotStatus] = useState('unknown');

  useEffect(() => {
    const check = () =>
      api.get('/status').then(r => r?.ok && setBotStatus(r.data.bot));
    check();
    const t = setInterval(check, 20_000);
    return () => clearInterval(t);
  }, []);

  return (
    <div style={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
      {/* Sidebar */}
      <aside style={{
        width: 220, flexShrink: 0, background: 'var(--bg2)',
        borderRight: '1px solid var(--border)', display: 'flex',
        flexDirection: 'column', padding: '16px 0',
      }}>
        <div style={{ padding: '0 16px 16px', borderBottom: '1px solid var(--border)' }}>
          <div style={{ fontSize: 18, fontWeight: 700, color: 'var(--text)' }}>🎫 Support</div>
          <div style={{ fontSize: 12, color: 'var(--text2)', marginTop: 4 }}>
            <span style={{
              display: 'inline-block', width: 8, height: 8, borderRadius: '50%',
              background: botStatus === 'online' ? 'var(--green)' : 'var(--red)',
              marginRight: 6,
            }} />
            Bot {botStatus}
          </div>
        </div>

        <div style={{ flex: 1 }} />

        {/* User info */}
        <div style={{
          padding: '12px 16px', borderTop: '1px solid var(--border)',
          display: 'flex', alignItems: 'center', gap: 10,
        }}>
          <img
            src={user.avatarUrl || `https://cdn.discordapp.com/embed/avatars/0.png`}
            alt=""
            style={{ width: 32, height: 32, borderRadius: '50%' }}
          />
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 13, fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {user.username}
            </div>
            <div style={{ fontSize: 11, color: 'var(--text2)' }}>{user.tier?.label || 'User'}</div>
          </div>
          <button
            onClick={logout}
            title="Logout"
            style={{ background: 'none', padding: 4, color: 'var(--text3)', fontSize: 16 }}
          >↩</button>
        </div>
      </aside>

      {/* Main content */}
      <main style={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
        {botStatus === 'offline' && (
          <div style={{
            background: '#2a1010', borderBottom: '1px solid #3a1818',
            padding: '8px 20px', color: 'var(--red)', fontSize: 13, textAlign: 'center',
          }}>
            ⚠️  The Discord bot is currently offline. New tickets can't be created and transcripts won't generate until it's back online.
          </div>
        )}
        <div style={{ flex: 1, overflow: 'auto', padding: 24 }}>
          {children}
        </div>
      </main>
    </div>
  );
}
